import { isBytesTag, isUndecoded } from './dbCellTags';

/**
 * Text projections of a grid cell.
 *
 * These live apart from the grid component so anything that needs to reason
 * about a cell's text — search, export, the detail modal — can share one
 * definition instead of each rebuilding "what does this cell say".
 */

/**
 * String form of a cell for editing/copying: objects (JSON columns) are
 * stringified, null is the empty string (callers track NULL separately).
 * The two tagged shapes get their own text rather than their raw wrapper JSON:
 * a blob copies as its base64, and an undecodable value says so instead of
 * pasting {"__undecoded":"interval"} into someone's spreadsheet.
 */
export function cellToText(v) {
  if (v === null || v === undefined) return '';
  if (isBytesTag(v)) return v.b64;
  if (isUndecoded(v)) return `<undecoded:${v.__undecoded}>`;
  return typeof v === 'object' ? JSON.stringify(v) : String(v);
}

export function formatByteLen(n) {
  if (!Number.isFinite(n)) return 'binary';
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(1)} KB`;
  return `${(n / (1024 * 1024)).toFixed(1)} MB`;
}
